module.exports = __webpack_public_path__ + "static/media/preload_video.877b9d8d.svg";